import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminEntityTagsQueryKey } from "../entity.keys";

export const useAdminFetchAllEntityTags = (shouldSkipQuery?: boolean) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: adminEntityTagsQueryKey(),
		queryFn: async () => {
			if (shouldSkipQuery) {
				return [] as Dtos.Tag.GetAll.Response;
			}
			const response = await get<Dtos.Tag.GetAll.Response>("/v2/admin/tags");
			return response.sort((a, b) => a.displayName.localeCompare(b.displayName));
		},
	});

	return {
		entityTags: data || [],
		entityTagsLoading: isLoading,
		entityTagsError: error,
		refetchEntityTags: refetch,
	};
};
